import React from "react";
import "./App.css";
import { Route, Routes } from "react-router-dom";

import PageHome from "./pages/home";

function App() {
  return (
    <Routes>
      <Route path="/" element={<PageHome />} />
    </Routes>
  );
}

export default App;
